import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';

// Drip content: unlock a module X days after the learner enrols (off by default)
export const ModuleDelayDialog = ({ module, onSave, onClose }) => {
  const [enabled, setEnabled] = useState(false);
  const [days, setDays] = useState(7);

  useEffect(() => {
    if (!module) return;
    setEnabled((module.unlock_after_days || 0) > 0);
    setDays(module.unlock_after_days || 7);
  }, [module]);

  if (!module) return null;
  return (
    <Dialog open={!!module} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="module-delay-dialog">
        <DialogHeader>
          <DialogTitle>Unlock delay</DialogTitle>
          <DialogDescription>{module.title}</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <Label>Delay this module</Label>
            <Switch checked={enabled} onCheckedChange={setEnabled} data-testid="module-delay-toggle" />
          </div>
          {enabled && (
            <div className="flex items-center gap-2">
              <span className="text-sm">Unlock</span>
              <Input type="number" min="1" max="365" className="w-24" value={days} onChange={(e) => setDays(Math.max(1, parseInt(e.target.value) || 1))} data-testid="module-delay-days" />
              <span className="text-sm">days after enrolment</span>
            </div>
          )}
          <p className="text-xs text-slate-500">Learners see this module with a lock icon and its unlock date until then. Admins are never blocked.</p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button className="bg-[#20acf6] hover:bg-[#3bb8f7]" onClick={() => onSave(enabled ? days : 0)} data-testid="module-delay-save-btn">Save</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
